export const PREVIOUS_ITEM_LIST_ID = 'item_list_id';
export const PREVIOUS_ITEM_LIST_NAME = 'item_list_name';

export function pushToLocalStorage<T>(key: string, value: T) {
  localStorage.setItem(key, JSON.stringify(value));
}
